'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var designTokens = require('../../designTokens.js');

var borderRadiusMap = {
  xs: designTokens.flxSizeBorderRadiusTiny,
  sm: designTokens.flxSizeBorderRadiusSmall,
  md: designTokens.flxSizeBorderRadiusMedium,
  lg: designTokens.flxSizeBorderRadiusLarge,
  xl: designTokens.flxSizeBorderRadiusXLarge,
  clear: 0
};
var spacingMap = {
  xxTiny: designTokens.flxSpacingXxTiny,
  xTiny: designTokens.flxSpacingXTiny,
  tiny: designTokens.flxSpacingTiny,
  xs: designTokens.flxSpacingXSmall,
  sm: designTokens.flxSpacingSmall,
  md: designTokens.flxSpacingMedium,
  lg: designTokens.flxSpacingLarge,
  xl: designTokens.flxSpacingXLarge,
  xxl: designTokens.flxSpacingXxLarge,
  clear: 0
};
var borderRadiusEnums = Object.keys(borderRadiusMap);
var spacingEnums = Object.keys(spacingMap);

exports.borderRadiusEnums = borderRadiusEnums;
exports.borderRadiusMap = borderRadiusMap;
exports.spacingEnums = spacingEnums;
exports.spacingMap = spacingMap;
